import * as actionType from "../../constants";
import * as commonData from "../../Common";
import axios from "axios";
import updateAttachmentData from "../updateAttachmentData";

let fileArray = { attachment: {} };

export const UploadImage = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  dispatch({
    type: actionType.IMAGE_UPLOAD_START,
  });
  try {
    const allpro = inputs.images.map((file) => {
      let formdata = new FormData();
      formdata.append("app_token", inputs.app_token);
      formdata.append("product_key", inputs.product_key);
      formdata.append(`image`, file);
      return new Promise((resolve, reject) => {
        axios
          .post(`${url}attachment/upload`, formdata, {
            headers: {
              "Content-Type": "multipart/formdata",
            },
            onUploadProgress: (progress) => {
              const { loaded, total } = progress;
              const percentageProgress = Math.floor((loaded / total) * 100);
              if (inputs.key === "add_listing") {
                if (percentageProgress === 100) {
                  dispatch({
                    type: actionType.IMAGE_UPLOAD_PROGRESS_COMPLETE_ADD_LISTING,
                    payload: {
                      image_name: file.name,
                      is_complete: true,
                      progress: percentageProgress,
                      size: file.size,
                    },
                  });
                } else {
                  dispatch({
                    type: actionType.IMAGE_UPLOAD_PROGRESS_ADD_LISTING,
                    payload: {
                      image_name: file.name,
                      progress: percentageProgress,
                      is_complete: false,
                      size: file.size,
                    },
                  });
                }
              } else {
                if (percentageProgress === 100) {
                  dispatch({
                    type: actionType.IMAGE_UPLOAD_PROGRESS_COMPLETE,
                    payload: {
                      id: inputs.customer_tattle_uuid,
                      image_name: file.name,
                      is_complete: true,
                      progress: percentageProgress,
                      size: file.size,
                    },
                  });
                } else {
                  dispatch({
                    type: actionType.IMAGE_UPLOAD_PROGRESS,
                    payload: {
                      id: inputs.customer_tattle_uuid,
                      image_name: file.name,
                      progress: percentageProgress,
                      is_complete: false,
                      size: file.size,
                    },
                  });
                }
              }
            },
          })
          .then((resp) => {
            const { data } = resp;
            if (data.code === 200) {
              resolve(resp);
              if (inputs.key === "customer_tattle_uuid") {
                dispatch({
                  type: actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS_AFTER_UPLOAD,
                  payload: { attachments: data?.data || {} },
                });
              }
              return resolve(resp);
            } else {
              reject(resp);
              if (inputs.key === "add_listing") {
                dispatch({
                  type: actionType.IMAGE_UPLOAD_ERROR_ADD_LISTING,
                  payload: {
                    image_name: file.name,
                    is_complete: false,
                    progress: 0,
                    is_error: true,
                    size: file.size,
                  },
                });
              } else {
                dispatch({
                  type: actionType.IMAGE_UPLOAD_ERROR,
                  payload: {
                    id: inputs.customer_tattle_uuid,
                    image_name: file.name,
                    is_complete: false,
                    progress: 0,
                    is_error: true,
                    size: file.size,
                  },
                });
              }
            }
          })
          .catch((error) => {
            if (inputs.key === "add_listing") {
              dispatch({
                type: actionType.IMAGE_UPLOAD_ERROR_ADD_LISTING,
                payload: {
                  image_name: file.name,
                  is_complete: false,
                  progress: 0,
                  is_error: true,
                  size: file.size,
                },
              });
            } else {
              dispatch({
                type: actionType.IMAGE_UPLOAD_ERROR,
                payload: {
                  id: inputs.customer_tattle_uuid,
                  image_name: file.name,
                  error: error.message,
                  is_complete: false,
                  progress: 0,
                  is_error: true,
                  size: file.size,
                },
              });
            }
            return reject(error);
          });
      });
    });

    const requests = Promise.allSettled(allpro);
    requests
      .then((pro) => {
        return Promise.allSettled(pro);
      })
      .then((ss) => {
        ss.forEach((item) => {
          const { status, value } = item;
          console.log(status, value, 654321324654);
          if (value && value.status === "fulfilled") {
            fileArray = {
              ...fileArray,
              app_token: inputs.app_token,
              attribute_set_key: inputs.attribute_set_key,
              [inputs.key]: inputs[inputs.key],
              key: inputs.key,
              attachment: {
                ...{
                  ...(inputs.key === "note"
                    ? {
                        [inputs.key]: {
                          ...fileArray?.attachment[inputs.key],
                          ...value?.value?.data?.data,
                        },
                      }
                    : {
                        [inputs.key]: {
                          ...fileArray.attachment?.[inputs.key],
                          ...value?.value?.data?.data,
                        },
                      }),
                },
              },
            };
          }
        });
        if (inputs.key === "customer_tattle_uuid") {
          const newfile = {
            ...fileArray,
            [inputs.key]: inputs[inputs.key],
            customer_tattle_uuid: inputs.customer_tattle_uuid,
          };
          dispatch(
            updateAttachmentData({
              ...newfile,
              attachment: { ...newfile.attachment["customer_tattle_uuid"] },
            })
          );
        } else if (inputs.key === "add_listing") {
          dispatch({
            type: actionType.IMAGE_UPLOAD_DONE_ADD_LISTING,
            payload: fileArray.attachment,
          });
        } else if (inputs.key === "child_board_er") {
          dispatch({
            type: actionType.IMAGE_UPLOAD_DONE_ADD_LISTING_CHILD_BOARD,
            payload: fileArray.attachment,
          });
        } else {
          if (inputs.hasOwnProperty("edit")) {
            dispatch({
              type: actionType.IMAGE_UPLOAD_DONE_EDIT,
              payload: fileArray.attachment,
            });
          } else {
            dispatch({
              type: actionType.IMAGE_UPLOAD_DONE,
              payload: fileArray.attachment,
            });
          }
        }
      });
    return requests;
  } catch (error) {
    console.log(error);
  }
};
export const clearFileArray = () => (dispatch) => {
  fileArray = { attachment: {} };
};
